import { Star, Quote, Users, TrendingUp, Award } from "lucide-react";

const Testimonials = () => {
  const testimonials = [
    {
      quote: "As a language teacher, this extension is invaluable. My students can finally understand pronunciation without me having to spell everything out repeatedly.",
      author: "Dr. Maria Santos",
      role: "Spanish Language Professor",
      company: "UCLA",
      avatar: "MS",
    },
    {
      quote: "I use PhoneticPro daily in our call center. Spelling customer names with NATO phonetics has never been easier. Saves us so much time!",
      author: "James Wilson",
      role: "Call Center Manager",
      company: "TechSupport Inc.",
      avatar: "JW",
    },
    {
      quote: "Perfect for aviation communications. The NATO alphabet conversion is instant and accurate. A must-have for pilots and dispatchers.",
      author: "Captain Lisa Chen",
      role: "Commercial Pilot",
      company: "United Airlines",
      avatar: "LC",
    },
    {
      quote: "The IPA conversion feature is incredible for my linguistics research. It handles complex phonetic transcriptions effortlessly.",
      author: "Prof. David Miller",
      role: "Linguistics Researcher",
      company: "MIT",
      avatar: "DM",
    },
    {
      quote: "Working in emergency services, clear communication is critical. PhoneticPro helps us relay addresses and codes without any confusion.",
      author: "Sarah Thompson",
      role: "911 Dispatcher",
      company: "NYC Emergency Services",
      avatar: "ST",
    },
    {
      quote: "Teaching English pronunciation to non-native speakers is so much easier now. The real-time conversion helps students see phonetics instantly.",
      author: "Michael Park",
      role: "ESL Instructor",
      company: "British Council",
      avatar: "MP",
    },
  ];

  const stats = [
    { value: "5,000+", label: "Active Users", icon: Users },
    { value: "4.9/5", label: "Average Rating", icon: Award },
    { value: "1M+", label: "Conversions Daily", icon: TrendingUp },
  ];

  return (
    <section className="py-24 px-6 bg-muted/30">
      <div className="max-w-5xl mx-auto">
        {/* Stats */}
        <div className="grid grid-cols-3 gap-6 mb-16">
          {stats.map((stat) => {
            const IconComponent = stat.icon;
            return (
              <div key={stat.label} className="text-center">
                <div className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-primary/10 mb-3">
                  <IconComponent className="w-5 h-5 text-primary" />
                </div>
                <div className="text-2xl md:text-3xl font-bold mb-1">{stat.value}</div>
                <div className="text-sm text-muted-foreground">{stat.label}</div>
              </div>
            );
          })}
        </div>

        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl font-semibold mb-3">
            Loved by Professionals
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            Join thousands of language teachers, call center agents, and communication professionals.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index} 
              className="p-6 rounded-lg bg-card border border-border hover:border-foreground/20 transition-all animate-fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <Quote className="w-6 h-6 text-primary/30 mb-4" />
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 text-yellow-500 fill-yellow-500" />
                ))}
              </div>
              <p className="text-muted-foreground mb-6 leading-relaxed text-sm">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary/20 to-primary/40 flex items-center justify-center text-sm font-medium">
                  {testimonial.avatar}
                </div>
                <div>
                  <p className="font-medium text-sm">{testimonial.author}</p>
                  <p className="text-xs text-muted-foreground">
                    {testimonial.role} • {testimonial.company}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;